import { NOT_VERIFIED, VERIFIED, IN_PROCESS, REJECTED, ASKED_VERIFICATION, VERIFIED_MESSAGE_SHOWN, } from 'constants/userValidationStatus'
import { ROLE_ADMIN, ROLE_PARTNER, ROLE_GATE_MANAGER, ROLE_AGENCE, } from 'constants/roles'
import { STANDARD, FREE, GREEN, USER, } from 'constants/parkingTypes'
import { NOT_PAID, PAID, } from 'constants/withdrawalStatus'
import { BOOKED, WAIT_ACCEPT, CANCELED, REFUSED, HAS_CHECKOUT_NEEDS_RATING, HAS_CHECKOUT, } from 'constants/bookingStatus'
import { PARKING_NEEDS_VALIDATION, PARKING_VALIDATED, PARKING_REJECTED, } from 'constants/parkingStatus'

export const formatVerificationStatus = (verificationStatus) => {
  switch (verificationStatus) {
    case NOT_VERIFIED:
      return 'Not verified'
    case ASKED_VERIFICATION:
      return 'ID Asked'
    case VERIFIED:
    case VERIFIED_MESSAGE_SHOWN:
      return 'Verified'
    case IN_PROCESS:
      return 'Submitted'
    case REJECTED:
      return 'Rejected'
    default:
      return ''
  }
}

export const formatRoles = (roles) => {
  switch (roles) {
    case ROLE_ADMIN:
      return 'Admin'
    case ROLE_PARTNER:
      return 'Partner'
    case ROLE_GATE_MANAGER:
      return 'Gate Manager'
    case ROLE_AGENCE:
      return 'Agence'
    default:
      return ''
  }
}

export const formatBookingStatus = (status) => {
  const statusFormated = Number(status)

  switch (statusFormated) {
    case BOOKED:
      return 'Booked'
    case WAIT_ACCEPT:
      return 'Pending'
    case CANCELED:
      return 'Canceled'
    case REFUSED:
      return 'Refused'
    case HAS_CHECKOUT:
      return 'FINISHED'
    case HAS_CHECKOUT_NEEDS_RATING:
      return 'Needs Owner Rating'
    default:
      return ''
  }
}

export const formatParkingType = (type) => {
  const typeFormated = Number(type)

  switch (typeFormated) {
    case STANDARD:
      return 'Partner'
    case FREE:
      return 'Free'
    case GREEN:
      return 'Green'
    case USER:
      return 'User'
    default:
      return ''
  }
}

export const getRestrictedParkings = (user) => {
  switch (user.roles) {
    case 'partner':
      return user.manager
    case 'gate_manager':
      return user.gateManager
    case 'admin':
      return null
    default:
      return ''
  }
}

export const formatWithdrawalStatus = (type) => {
  const typeFormated = Number(type)

  switch (typeFormated) {
    case NOT_PAID:
      return 'Pending'
    case PAID:
      return 'Paid'
    default:
      return ''
  }
}

export const formatParkingStatus = (status) => {
  const statusFormated = Number(status)

  switch (statusFormated) {
    case PARKING_NEEDS_VALIDATION:
      return 'Pending'
    case PARKING_REJECTED:
      return 'Rejected'
    case PARKING_VALIDATED:
      return 'Validated'
    default:
      return ''
  }
}
